import React from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import PurpleSwitch from '../../../components/FilterSwitch/PurpleSwitch';
import { BLACK } from '../../../theme/colorConstants';
import { PRIMARY_FONT } from '../../../theme/fontConstants';

const SwitchRow = ({
  text,
  subText,
  checked,
  onChange,
  disabled = false,
  divider = true,
  adornment,
}) => (
  <Box
    sx={{
      alignItems: 'center',
      borderBottom: divider ? `1px solid ${BLACK[20]}` : 'none',
      display: 'flex',
      gap: '16px',
      justifyContent: 'space-between',
      padding: '12px 0',
    }}
  >
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '2px', minWidth: 0 }}>
      <Typography
        sx={{
          color: BLACK[100],
          fontFamily: PRIMARY_FONT[500],
          fontSize: '14px',
        }}
      >
        {text}
      </Typography>
      <Typography
        sx={{
          color: BLACK[70],
          fontFamily: PRIMARY_FONT[400],
          fontSize: '13px',
        }}
      >
        {subText}
      </Typography>
    </Box>
    <Box sx={{ alignItems: 'center', display: 'flex', flexShrink: 0, gap: '12px' }}>
      {adornment}
      <PurpleSwitch
        checked={checked}
        disabled={disabled}
        inputProps={{ 'aria-label': text }}
        onChange={onChange}
      />
    </Box>
  </Box>
);

SwitchRow.propTypes = {
  text: PropTypes.string.isRequired,
  subText: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  divider: PropTypes.bool,
  adornment: PropTypes.node,
};

export default SwitchRow;
